export const InquiryStatus = Object.freeze({
  WAITING: 0,
  IN_PROGRESS: 1,
  DONE: 2,
});

export const getInquiryStatusBadgeType = (status) => {
  if (status === InquiryStatus.WAITING) {
    return "waiting";
  }
  if (status === InquiryStatus.IN_PROGRESS) {
    return "inProgress";
  }
  return "done";
};

export const isInquiryDone = (status) => status === InquiryStatus.DONE;
